import { Ref, ref } from "vue";
import { Syozoku } from "@/types/Syozoku";
import { BaseOptionWithoutCode } from "@/types/Option";
import { MstSyozokuService } from "@/service/MstSyozokuService";

export function useSyozoku() {
  const srv = new MstSyozokuService()
  const syozokus: Ref<Syozoku[]> = ref([]);
  const syozokuOptions: Ref<BaseOptionWithoutCode[]> = ref([]);

  const getAllSyozoku = async () => {
    syozokus.value = await srv.getAll();
  }

  const getAllSyozokuOptions = async () => {
    syozokuOptions.value = await srv.getAllOptions();
  }

  return {
    getAllSyozoku,
    getAllSyozokuOptions,
    syozokus,
    syozokuOptions
  }
}
